export type ThemeName = 'blue' | 'green' | 'purple' | 'orange' | 'golden';

export interface ThemeColors {
  primary: string;
  primaryDark: string;
  primaryLight: string;
  primaryLighter: string;
  lightBackground: string;
  primaryRgba: string;
  primaryDarkRgba: string;
  gradient: string;
  gradientHorizontal: string;
}

export const themes: Record<ThemeName, ThemeColors> = {
  blue: {
    primary: '#0EA5E9',
    primaryDark: '#0284C7',
    primaryLight: '#38BDF8',
    primaryLighter: '#60A5FA',
    lightBackground: '#E0F2FE',
    primaryRgba: '14, 165, 233',
    primaryDarkRgba: '2, 132, 199',
    gradient: 'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)',
    gradientHorizontal: 'linear-gradient(90deg, #0EA5E9 0%, #0284C7 100%)',
  },
  green: {
    primary: '#10B981',
    primaryDark: '#059669',
    primaryLight: '#34D399',
    primaryLighter: '#6EE7B7',
    lightBackground: '#D1FAE5',
    primaryRgba: '16, 185, 129',
    primaryDarkRgba: '5, 150, 105',
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
    gradientHorizontal: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
  },
  purple: {
    primary: '#8B5CF6',
    primaryDark: '#7C3AED',
    primaryLight: '#A78BFA',
    primaryLighter: '#C4B5FD',
    lightBackground: '#EDE9FE',
    primaryRgba: '139, 92, 246',
    primaryDarkRgba: '124, 58, 237',
    gradient: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
    gradientHorizontal: 'linear-gradient(90deg, #8B5CF6 0%, #7C3AED 100%)',
  },
  orange: {
    primary: '#F97316',
    primaryDark: '#EA580C',
    primaryLight: '#FB923C',
    primaryLighter: '#FDBA74',
    lightBackground: '#FFEDD5',
    primaryRgba: '249, 115, 22',
    primaryDarkRgba: '234, 88, 12',
    gradient: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
    gradientHorizontal: 'linear-gradient(90deg, #F97316 0%, #EA580C 100%)',
  },
  golden: {
    primary: '#F4C430',
    primaryDark: '#E6B82E',
    primaryLight: '#FFD700',
    primaryLighter: '#FFED4E',
    lightBackground: '#FFF9E6',
    primaryRgba: '244, 196, 48',
    primaryDarkRgba: '230, 184, 46',
    gradient: 'linear-gradient(135deg, #F4C430 0%, #E6B82E 100%)',
    gradientHorizontal: 'linear-gradient(90deg, #F4C430 0%, #E6B82E 100%)',
  },
};

export const getTheme = (themeName: ThemeName = 'blue'): ThemeColors => {
  return themes[themeName] || themes.blue;
};

export const getThemeFromEnv = (): ThemeName => {
  const envTheme = process.env.REACT_APP_THEME?.toLowerCase() as ThemeName;
  if (envTheme && themes[envTheme]) {
    return envTheme;
  }
  return 'blue'; // Default theme
};

